import { Grid, IconButton, Tooltip } from '@mui/material'
import { format, startOfToday } from 'date-fns'
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
  useMemo,
} from 'react'
import { useImmerReducer } from 'use-immer'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import { ButtonSelectedAgenda } from './components/ButtonSelectedAgenda'
import { StaticsDay } from './components/StaticsDay'
import { IoPersonCircleOutline } from 'react-icons/io5'
import { ConsultsList } from './components/schedule-calendar'

const initialValues = {
  statics: {
    agendamentos: 0,
    preparacao: 0,
    confirmados: 0,
    aguardando: 0,
    atendido: 0,
    cancelado: 0,
    finalizado: 0,
  },
  consults: [],
  selectedDay: startOfToday(),
  agendamentoSelecionado: {
    modal: false,
    data: null,
  },
  medico: null,
}

const reducer = (state = initialValues, { type, field, value }) => {
  switch (type) {
    case 'setStatics':
      state.statics = value
      break
    case 'setConsults':
      state.consults = value
      break
    default:
      state[field] = value
  }
}
export const AgendaContext = createContext(initialValues)

const Agenda = () => {
  const { agenda } = useContext(GlobalContext)
  const [ferramentas, setFerramentas] = useState()

  const [state, dispatch] = useImmerReducer(reducer, initialValues)

  const contextValues = useMemo(
    () => ({ ...state, dispatch }),
    [state, dispatch],
  )

  const { selectedDay } = state

  const vaiPrograma = (programa) => {
    window.location.href = programa
  }

  const listaAgendamentos = useCallback(() => {
    setFerramentas(
      <>
        <Tooltip title="Pacientes">
          <IconButton
            onClick={() => vaiPrograma('/programas/cadastro/paciente')}
          >
            <IoPersonCircleOutline />
          </IconButton>
        </Tooltip>
      </>,
    )
    metodoPrograma(
      'lista',
      { idAgenda: agenda[0], data: format(selectedDay, 'yyyy-MM-dd') },
      'CtrlAgendamento',
    ).then((res) => {
      if (res.status) {
        dispatch({ type: 'setStatics', value: returnStatics(res.estatistica) })
        dispatch({ type: 'setConsults', value: res.lista })
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDay, agenda, dispatch, state.agendamentoSelecionado?.modal])

  function returnStatics(estatistica) {
    return {
      agendamentos: estatistica.agendamentos || 0,
      preparacao: estatistica.preparacao || 0,
      confirmados: estatistica.confirmados || 0,
      aguardando: estatistica.aguardando || 0,
      atendido: estatistica.atendido || 0,
      cancelado: estatistica.cancelado || 0,
      finalizado: estatistica.finalizado || 0,
    }
  }

  useEffect(() => {
    if (agenda) {
      listaAgendamentos()
    }
  }, [listaAgendamentos, agenda])

  return (
    <AgendaContext.Provider value={contextValues}>
      <Programa codigo={'CtrlAgendamento'} ferramentas={ferramentas}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={10}>
            <ConsultsList {...{ agenda, listaAgendamentos }} />
          </Grid>
          <Grid item xs={12} sm={2}>
            <div className="flex flex-col gap-2 mt-10">
              <ButtonSelectedAgenda />
              <StaticsDay />
            </div>
          </Grid>
        </Grid>
      </Programa>
    </AgendaContext.Provider>
  )
}

export default Agenda
